<script>
import Article from '../components/Utils/Article'
import Ascii from '../components/Utils/Ascii'
export default {
  name: 'NotFound',
  components: { 
    Article,
    Ascii 
  },
  data() {
    return {
      Contents: "# 503 \n\n Error connecting to the server;  \n  Please contact [karl](mailto:bonjour@moubarak.eu)."
    }
  },
}
</script>

<template>
  <main 
    lang="en"
    id="app"
  >
    <Ascii />
    <Article 
      :sections="[{ Contents }]"
    />
  </main>
</template>

<style scoped>

:root {
  --background: rgb(3, 29, 11);
  --copy: rgb(231, 231, 231);
}

html,
body,
#app {
  margin: 0; padding: 0;
  height: 100%; width: 100%;
  font-family: monospace;
  color: var(--copy);
  background: var(--background);
}

#app {
  display: flex;
}

#app article {
  margin: auto;
}

</style>
